import moment from 'moment'
import cookies from 'js-cookie'

export function checkTokenExpired() {
  const at = cookies.get('sm_at')
  const et = cookies.get('sm_at_et')
  const unixtime = parseInt(moment.utc().format('X'), 10)
  const isLogin = at && unixtime <= et

  return isLogin === false
}
